import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs';
import { BaseResizableComponent } from '@src/app/modules/base';
import { fixRouteParam } from '@src/utils';
import { PagesService } from '@src/app/modules/pages';

@Component({
  selector: 'app-custom-page',
  templateUrl: './custom-page.component.html',
  styleUrls: ['./custom-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomPageComponent extends BaseResizableComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly pagesService = inject(PagesService);

  pageId?: string;

  override ngOnInit(): void {
    super.ngOnInit();

    this.route.paramMap.pipe(takeUntil(this.destroyed$$)).subscribe(query => {
      this.pageId = fixRouteParam(query.get('pageId'));
      this.cdr.markForCheck();
    });
  }

  protected onDeleted() {
    this.reload();
    this.router.navigate(['']);
  }

  protected reload() {
    this.pagesService.getPagesForNavigation();
    this.cdr.markForCheck();
  }
}
